module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "productCenter",
      "name": "productCenter"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/images/productCenter/productCenterIcon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue section-title"
  }, [_vm._v(_vm._s(_vm.t('productCenterTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "en-products"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.products), function(row) {
    return _c('div', {
      staticClass: "en-product-row"
    }, _vm._l((row), function(item) {
      return _c('a', {
        attrs: {
          "href": item.link
        }
      }, [_c('div', {
        staticClass: "thumbnail"
      }, [_c('div', {
        staticClass: "cover"
      }, [_c('img', {
        attrs: {
          "src": item.url,
          "alt": item.title
        }
      })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.t(item.title)))])])])
    }))
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docode-container"
  }, [_c('img', {
    attrs: {
      "src": "assets/images/productCenter/docode.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "docode-text"
  }, [_c('h1', [_vm._v("Docode"), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("NEW")])]), _vm._v(" "), _c('p', [_vm._v("\n          The ultimate solution for mobile payment in the world.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "explore-more"
  }, [_c('a', {
    attrs: {
      "href": "./docode.html"
    }
  }, [_vm._v("Explore More")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7baae9a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/ProductCenter.vue
// module id = 416
// module chunks = 3